import style from "./FirstBlockCard.module.css";
import UserStore from "../../../../store/user-store";
import {observer} from "mobx-react-lite";

const getGradientStyle = (planId) => {
    const gradients = {
        1: "rgb(11,83,191)",
        3: "rgb(0,128,255)",
        default: "#00ff9e"
    };
    return {backgroundColor: gradients[planId] || gradients.default};
};

const PriceDisplay = ({isRu, price, currency}) => (
    <>
        {isRu ? (
            <>
                {price}
                <span style={{opacity: 0.5}}>{currency}</span>
            </>
        ) : (
            <>
                <span style={{opacity: 0.5}}>{currency}</span>
                {price}
            </>
        )}
    </>
);

export const FirstBlockCard = observer(({props, plan_config_index, PLAN_CONFIGURATION}) => {
    const isRu = UserStore.langCode === "ru";
    const planPrice = props.plan_prices[plan_config_index];
    const basePrice = isRu ? Number(planPrice.rub_base_price) : Number(planPrice.usd_base_price);
    const currency = isRu ? "₽" : "$";
    const saleAmount = Number(props.plan_prices[plan_config_index].sale_amount) || 0;
    const hasSale = saleAmount > 0;
    const discountedPrice = isRu ? planPrice.rub_sale_price : planPrice.usd_sale_price;
    const planConfigData = PLAN_CONFIGURATION[plan_config_index];

    return (
        <div className={style.vpn_card__main__fist_block}>
            <div className={style.gradient} style={getGradientStyle(props.plan_id)}/>

            {/*<div className={style.vpn_card__main__fist_block__img_holder}>*/}
            {/*    <img width="110" height="120" src={props.img_src} alt="plan_image"/>*/}
            {/*</div>*/}

            <div className={style.vpn_card__main__fist_block__price}>
                <div className="flex-center" style={{gap: "10px", display: "flex",}}>
                    {hasSale && (

                        <div className={style.vpn_card__main__fist_block__price__sale}>
                            <p>-{saleAmount}%</p>
                        </div>

                    )}
                    <div className={style.vpn_card__main__fist_block__price__sale}>
                        {planConfigData.icon}
                        {planConfigData.name}
                    </div>
                </div>


                <div className={style.vpn_card__main__fist_block__price__text}>
                    <h1 className="plan_name_h1">{props.plan_name}</h1>

                    <div className="plan_price" style={{display: "flex", gap: "5px", alignItems: "flex-start"}}>
                        <p style={{color: "white", fontWeight: "bold", fontSize: isRu ? 42 : 52}}>
                            <PriceDisplay
                                isRu={isRu}
                                price={hasSale ? discountedPrice : basePrice}
                                currency={currency}
                            />
                        </p>

                        {hasSale && (
                            <p style={{textDecoration: "line-through", opacity: 0.5, fontSize: isRu ? 21 : 28}}>
                                {isRu ? basePrice + "₽" : "$" + basePrice}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});
